import Vue from "vue";
import store from "./store";
import router from "./router";
import * as echarts from "echarts";
import ElementUI from "element-ui";
import { marked } from "marked";
import App from "./App";
import SpanSticky from "@/utils/spanSticky";

import "element-ui/lib/theme-chalk/index.css";
import "@/assets/styles/index.scss"; // global css
import "./assets/style/table.scss";
import "./assets/style/global.css";
import "./assets/style/global.scss";
import "./assets/style/mixis.scss";
import "./assets/style/element-variables.scss"; //改变主题颜色
import 'element-tree-line/dist/style.css'
import ElementTreeLine from 'element-tree-line';

Vue.component(ElementTreeLine.name, ElementTreeLine);

import { uploadPointData } from "@/api/home";


import dayJs from "dayjs";
import Vuex from "vuex";
import clipboard from "clipboard";

// 懒加载
import VueLazyload from "vue-lazyload";

// 懒加载
Vue.use(VueLazyload, {
  // ""懒加载默认图片路径
  // loading: require(""),
});

Vue.prototype.clipboard = clipboard;

import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

import utils from "./utils/util.js";
import "./assets/font/font.css";
import "./assets/reset.css";
import "./assets/rem";

Vue.prototype.$dayJs = dayJs;

Vue.prototype.$echarts = echarts;

Vue.prototype.$myVue = Vue;

Vue.config.productionTip = false;

// Vue.prototype.bus = new Vue();

Vue.use(ElementUI, {
  size: "small",
});
Vue.use(dayJs);
// Vue.use(echarts);
Vue.use(utils);
Vue.use(Vuex);

Vue.filter("numberThree", (val) => {
  return Number(val).toLocaleString();
});

import BIButton from "@/components/new/bi-button.vue";
import BITitle from "@/components/new/bi-title.vue";
import BITipBox from "@/components/new/tip-box.vue";
import PageTitle from "@/components/new/pageTitle.vue";
import aiToolsBtn from "@/components/ai/aiToolsBtn.vue"
import biBread from "@/components/new/bi-Bread.vue"

Vue.component("bi-button", BIButton);
Vue.component("bi-tip", BITipBox);
Vue.component("bi-title", BITitle);
Vue.component("page-title", PageTitle);
Vue.component("aiToolsBtn", aiToolsBtn)
Vue.component("bi-Bread", biBread)

import JDButton from "@/components/new/jd-button.vue";
import YSelectArea from "@/components/ySelectArea/index.vue";
import YSelectItem from "@/components/ySelectItem/index.vue";
import collect from "@/views/prefabricateReport/components/collectCom.vue";
import section from "@/views/prefabricateReport/components/sectionCom.vue";
import sectionCycle from "@/views/prefabricateReport/components/sectionCycle.vue";
import excludeAmountCom from "@/views/prefabricateReport/components/excludeAmountCom.vue";
import excludeProductCom from "@/views/prefabricateReport/components/excludeProductCom.vue";
import selectSkuCom from "@/views/prefabricateReport/components/selectSkuCom.vue";
import categoryCom from "@/views/prefabricateReport/components/categoryCom.vue";
import productTagsCom from "@/views/prefabricateReport/components/productTagsCom.vue";
import textOverflowTooltip from "@/views/prefabricateReport/components/textOverflowTooltip.vue";
import setUnitCom from "@/views/prefabricateReport/components/setUnitCom.vue";

Vue.component("jd-button", JDButton);
Vue.component("y-select-area", YSelectArea);
Vue.component("y-select-item", YSelectItem);
Vue.component("bi-collect", collect);
Vue.component("bi-section", section);
Vue.component("bi-section-cycle", sectionCycle);
Vue.component("excludeAmountCom", excludeAmountCom);
Vue.component("excludeProductCom", excludeProductCom);
Vue.component("selectSkuCom", selectSkuCom);
Vue.component("categoryCom", categoryCom);
Vue.component("productTagsCom", productTagsCom);
Vue.component("textOverflowTooltip", textOverflowTooltip);
Vue.component("setUnitCom", setUnitCom);

// 合并单元格内容滚动吸顶：全局对所有 el-table 自动生效，模板无需任何标记。
// 个别表格要调参可写 v-span-sticky="{ bottomGap, threshold, offsetTop, selector }"，传 false 则关闭。
Vue.use(SpanSticky);

Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 3000);
      }
    });
  },
});
// 输入框只能输入正整数
Vue.directive("numZOnly", {
  bind(el) {
    el.addEventListener("input", (event) => {
      const inputValue = event.target.value;
      event.target.value = inputValue.replace(/^(0+)|[^\d]+/g, "");
    });
  },
});

// 输入框只能输入数字
Vue.directive("numeric-only", {
  bind(el) {
    el.addEventListener("input", (event) => {
      const inputValue = event.target.value;
      const filteredValue = inputValue.replace(/[^\d.]/g, "");
      event.target.value = filteredValue;
    });
  },
});

let maidian = (value) => {
  if (window._hmt && !!value) {
    window._hmt.push(["_trackEvent", "按钮点击", "click", `BI-${value.from}-${value.name}`]);
  }
};
// 按钮埋点
Vue.directive("zoom", {
  inserted(el, binding) {
    el.onclick = () => maidian(binding.value);
  },

  update(el, binding) {
    let old = binding.oldValue.from;
    let newV = binding.value.from;
    if (old != newV) {
      // console.log(el);
      // el.removeEventListener('click', ()=>maidian(binding.oldValue),false)
      el.onclick = false;
      el.onclick = () => maidian(binding.value);
    }
  },
});
// 标签埋点
Vue.directive("labelZoom", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (window._hmt) {
        window._hmt.push(["_trackEvent", "标签选择", "active", `${binding.value.name}`]);
      }
    });
  },
});

Vue.directive("natural-number", {
  bind: function (el) {
    el.handler = function (e) {
      const input = e.target;
      input.value = input.value.replace(/[^0-9]/g, ""); // 只保留数字
    };
    el.addEventListener("input", el.handler);
  },
  unbind: function (el) {
    el.removeEventListener("input", el.handler);
  },
});

// JSEncrypt加密
const encryptMI = function (origin = Date.now()) {
  // 公钥
  const key =
    "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDa+vHCmfKZxVdMBbp69Stu4u11BlOqfEDXK8HqZJ8dKHArYd+78wMzvpQZcWFtdix8MYaTLQERIaxjRoLrGYvYiONi+dKaZ/SSAI8boATYb1Wimz/ocUIGGj2SSZwQ6l5xzOu7orKVdrzUMpqETbuxRwAeMe1ZP/YQ20aXmmGBgwIDAQAB";
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey(key);
  return encrypt.encrypt(origin + "");
};

//百度统计代码
var _hmt = _hmt || [];
window._hmt = _hmt;
(function () {
  var hm = document.createElement("script");
  hm.src = hm.src = "https://hm.baidu.com/hm.js?68e65e77b10e09e3bff6192dcf88de08";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

// 定时器标识
let timer = null;
let timeEnter = null;
let times = 0;

// 埋点计时器
Vue.prototype.setIntervalFun = async function (name, firstClassify, secondClassify, id) {
  if (!id) return;
  timer = setTimeout(() => {
    times = times + 1;
    // 页面停留超过1小时，停止埋点
    if (times >= 3600) {
      // console.log(times);
      this.$clearBuriedPoint();
      // console.log('停止埋点');
      return;
    }
    this.buriedPointTimes({
      name,
      firstClassify,
      secondClassify, 
      id
    });
  }, 2000);
};
// 清除埋点
Vue.prototype.$clearBuriedPoint = function () {
  clearTimeout(timer);
};

/**
 * 页面埋点
 * @param {*} action 类型 1进入页面 2点击按钮 3授权进入 4操作
 * @param {*} name 页面/按钮名称（类型为1、2的时候要有）
 * @param {*} firstClassify 一级菜单
 * @param {*} secondClassify 二级菜单
 * @param {*} type
 */
Vue.prototype.$buriedPoint = async function ({
  action,
  name,
  firstClassify,
  secondClassify,
  type = "",
}) {
  let flage = false;
  if (!flage) {
    this.$clearBuriedPoint();
    clearTimeout(timeEnter);
    flage = true;
  }
  if (flage) {
    let routes = this.$route.path + this.$route.hash.substring(1);
    setTimeout(async () => {
      times = 0;
      let params = {
        platform: "bip",
        venderId: "",
        shopTitle: "",
        source: 0, // 来源 0:pc端 1:移动端
        action, // 类型 1进入页面 2点击按钮 3授权进入 4操作
        url: routes, // 路径
        name, //"页面/按钮名称（1、2类型时要有）",
        sign: encryptMI(), //JSE加密
        firstClassify, // 一级分类
        secondClassify, // 二级分类
        type,
      };
      let { platformCompanyInfoId,  } = this.currentUserInfo || {};
      params.venderId = platformCompanyInfoId || null;
      sessionStorage.setItem('venderIdBI', platformCompanyInfoId || null)
      // 调用埋点
      const res = await uploadPointData(params);
      let id = res.data || null;
      this.buriedPointTimes({
        name,
        firstClassify,
        secondClassify, 
        id
      });
    }, 500);
  }
};

// 轮询埋点
Vue.prototype.buriedPointTimes = async function ({ name, firstClassify, secondClassify, id }) {
  var route = this.$route.path;
  let params = {
    platform: "bip",
    venderId: sessionStorage.getItem('venderIdBI') || null,
    shopTitle: "",
    source: 0, //来源 0:pc端 1:移动端
    action: 5, //类型 1进入页面 2点击按钮 3授权进入 4操作
    url: route, // 路径
    name, //"页面/按钮名称（1、2类型时要有）",
    sign: encryptMI(), //JSE加密
    firstClassify, // 一级分类
    secondClassify, // 二级分类
    requestId: id, // 请求id
  };
  // 调用埋点
  await uploadPointData(params);
  // 轮询-埋点
  this.$clearBuriedPoint();
  this.setIntervalFun(name, firstClassify, secondClassify, id);
};

Vue.prototype.$parseMarkdownToBlocks = function (md) {
  if (!md) return [];

  // 预处理：如果 ** 的前面一个字符是 %，在 ** 后面添加一个空格
	let processedMd = md.replace(/(%)(\*\*)/g, '$1$2 ');
	const lines = processedMd.split("\n");
  const blocks = [];
  let textBuf = []; // 累积的非表格文本行
  let tableLines = []; // 累积的表格行
  let tableConfirmed = false; // 是否已确认是表格（遇到分隔行）

  function flushText() {
    if (textBuf.length > 0) {
      const raw = textBuf.join("\n");
      if (raw.trim()) {
        blocks.push({ type: "markdown", html: marked.parse(raw) });
      }
      textBuf = [];
    }
  }

  function flushTable() {
    if (tableLines.length > 0 && tableConfirmed) {
      const rows = tableLines.map((line) =>
        line
          .split("|")
          .filter((c) => c.trim() !== "")
          .map((c) => c.trim())
      );
      // 跳过分隔行（|---|---|）
      const dataRows = rows.filter(
        (row) => !row.every((cell) => /^[-:]+$/.test(cell))
      );

      // 用 marked 渲染表格 HTML
      const tableMd = tableLines.join("\n");
      blocks.push({
        type: "table",
        html: marked.parse(tableMd),
        rows: dataRows,
      });
    } else if (tableLines.length > 0) {
      // 未确认的表格行当普通文本处理（流式中间态）
      textBuf.push(...tableLines);
    }
    tableLines = [];
    tableConfirmed = false;
  }

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const isTableRow = /^\s*\|/.test(line);
    const isSeparator = /^\s*\|[\s\-:|]+\|\s*$/.test(line);

    if (isTableRow) {
      // 如果之前有普通文本，先 flush
      if (textBuf.length > 0 && tableLines.length === 0) {
        flushText();
      }
      tableLines.push(line);
      if (isSeparator) {
        tableConfirmed = true;
      }
    } else {
      // 非表格行
      if (tableLines.length > 0) {
        flushTable();
      }
      textBuf.push(line);
    }
  }

  // 最后剩余的内容
  if (tableLines.length > 0) flushTable();
  if (textBuf.length > 0) flushText();

  return blocks;
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// 初始化 store
store.dispatch("user/initializeStore");
